module.exports = __webpack_public_path__ + "static/media/aplicacao.9a5bd460.gif";